import { Curve, Vector2, Vector3 } from 'three';

(Curve as any).prototype.distanceToPoint = function (this: Curve<Vector3>, p: Vector3, divisions = 128, project?: (v: Vector3) => Vector2) {
  return distancePointToPolyline(p, this.getSpacedPoints(divisions), project);
};

export function distancePointToPolyline(p: Vector3, pts: Vector3[], project?: (v: Vector3) => Vector2): number {
  if (pts.length === 0) return Infinity;
  if (pts.length === 1) {
    if (!project) return p.distanceTo(pts[0]);
    const a = project(pts[0]);
    const q = project(p);
    return Math.hypot(q.x - a.x, q.y - a.y);
  }

  let best2 = Infinity;
  if (!project) {
    for (let i = 0; i < pts.length - 1; i++) {
      const a = pts[i],
        b = pts[i + 1];
      const v = new Vector3().subVectors(b, a);
      const w = new Vector3().subVectors(p, a);
      const len2 = v.lengthSq();
      let t = 0;
      if (len2 > 1e-12) t = w.dot(v) / len2;
      if (t < 0) t = 0;
      else if (t > 1) t = 1;
      const c = new Vector3().copy(a).addScaledVector(v, t);
      const d2 = p.distanceToSquared(c);
      if (d2 < best2) best2 = d2;
    }
  } else {
    const q = project(p);
    for (let i = 0; i < pts.length - 1; i++) {
      const a = project(pts[i]),
        b = project(pts[i + 1]);
      const vx = b.x - a.x,
        vy = b.y - a.y;
      const wx = q.x - a.x,
        wy = q.y - a.y;
      const len2 = vx * vx + vy * vy;
      let t = 0;
      if (len2 > 1e-12) t = (wx * vx + wy * vy) / len2;
      if (t < 0) t = 0;
      else if (t > 1) t = 1;
      const cx = a.x + t * vx,
        cy = a.y + t * vy;
      const dx = q.x - cx,
        dy = q.y - cy;
      const d2 = dx * dx + dy * dy;
      if (d2 < best2) best2 = d2;
    }
  }
  return Math.sqrt(best2);
}
